const ENV_VARIABLES: any = {
  NEXT_PUBLIC_API_URL: process.env.NEXT_PUBLIC_API_URL,

  NEXT_PUBLIC_API_USERNAME: process.env.NEXT_PUBLIC_API_USERNAME,

  NEXT_PUBLIC_API_SECRET: process.env.NEXT_PUBLIC_API_SECRET,

  NEXT_PUBLIC_PAYSTACK_KEY: process.env.NEXT_PUBLIC_PAYSTACK_KEY,

  NEXT_PUBLIC_FLUTTERWAVE_KEY: process.env.NEXT_PUBLIC_FLUTTERWAVE_KEY,

  NEXT_PUBLIC_STRIPE_KEY: process.env.NEXT_PUBLIC_STRIPE_KEY,

  NEXT_PUBLIC_ENABLE_STRIPE: process.env.NEXT_PUBLIC_ENABLE_STRIPE,

  NEXT_PUBLIC_CLOUDINARY_BASE_URL: process.env.NEXT_PUBLIC_CLOUDINARY_BASE_URL,

  NEXT_PUBLIC_GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
  // NEXT_PUBLIC_STRIPE_USER_PRICE_ID:
  //   process.env.NEXT_PUBLIC_STRIPE_USER_PRICE_ID,
  // NEXT_PUBLIC_STRIPE_USER_PRICE_ID_NIGERIA:
  //   process.env.NEXT_PUBLIC_STRIPE_USER_PRICE_ID_NIGERIA,

  NEXT_PUBLIC_STRIPE_USER_PRICE_ID_BASIC:
    process.env.NEXT_PUBLIC_STRIPE_USER_PRICE_ID_BASIC,

  NEXT_PUBLIC_STRIPE_USER_PRICE_ID_BASIC_NIGERIA:
    process.env.NEXT_PUBLIC_STRIPE_USER_PRICE_ID_BASIC_NIGERIA,

  NEXT_PUBLIC_STRIPE_USER_PRICE_ID_PRO:
    process.env.NEXT_PUBLIC_STRIPE_USER_PRICE_ID_PRO,

  NEXT_PUBLIC_STRIPE_USER_PRICE_ID_PRO_NIGERIA:
    process.env.NEXT_PUBLIC_STRIPE_USER_PRICE_ID_PRO_NIGERIA,

  NEXT_PUBLIC_FIREBASE_PUBLIC_API_KEY:
    process.env.NEXT_PUBLIC_FIREBASE_PUBLIC_API_KEY,

  NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN:
    process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,

  NEXT_PUBLIC_FIREBASE_PROJECT_ID: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,

  NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET:
    process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,

  NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID:
    process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,

  NEXT_PUBLIC_FIREBASE_APP_ID: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,

  NEXT_PUBLIC_MEASUREMENT_ID: process.env.NEXT_PUBLIC_MEASUREMENT_ID,

  NEXT_PUBLIC_MIXPANEL_TOKEN: process.env.NEXT_PUBLIC_MIXPANEL_TOKEN,

  NEXT_PUBLIC_NODE_ENV:
    process.env.NEXT_PUBLIC_NODE_ENV || process.env.NODE_ENV,

  NEXT_PUBLIC_PRIMARY_PAYMENT: process.env.NEXT_PUBLIC_PRIMARY_PAYMENT,
}

export const envConfig = { ...ENV_VARIABLES }
